(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promotion-info"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('promotion-info-carousel')) {
  customElements.define('promotion-info-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const slides = [...this.querySelectorAll('.promotion-info__item')];
      const controls = this.querySelector('[data-carousel-controls]');

      if (slides.length < 2 || !controls) return;

      const mobile = matchMedia('(max-width: 749px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = this.dataset.autoplay === 'true';
      const delay = Math.max(2, Number(this.dataset.interval) || 4) * 1000;
      const counter = controls.querySelector('[data-counter]');

      let index = 0;

      const show = (next) => {
        index = (next + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });

        counter.textContent = `${index + 1} / ${slides.length}`;

        [index, (index + 1) % slides.length].forEach((i) => {
          const image = slides[i].querySelector('img');
          if (image) image.loading = 'eager';
        });
      };

      const start = () => {
        clearInterval(this.timer);

        if (
          this.isConnected &&
          autoplay &&
          mobile.matches &&
          !reducedMotion.matches &&
          !document.hidden &&
          !window.Shopify?.designMode
        ) {
          this.timer = setInterval(() => show(index + 1), delay);
        }
      };

      controls.querySelector('[data-prev]').addEventListener('click', () => {
        show(index - 1);
        start();
      }, options);

      controls.querySelector('[data-next]').addEventListener('click', () => {
        show(index + 1);
        start();
      }, options);

      document.addEventListener('visibilitychange', start, options);
      mobile.addEventListener('change', start, options);
      reducedMotion.addEventListener('change', start, options);

      this.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('.promotion-info__item');
        const selectedIndex = slides.indexOf(selected);

        if (selectedIndex >= 0) {
          show(selectedIndex);
        }
      }, options);

      show(0);
      this.setAttribute('data-carousel-ready', '');
      controls.hidden = false;
      start();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.removeAttribute('data-carousel-ready');

      const controls = this.querySelector('[data-carousel-controls]');
      if (controls) controls.hidden = true;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
